// extracted by mini-css-extract-plugin
export var notificationHost = "_kd-0";